var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-box',{attrs:{"container":"","p":"6"}},[_c('v-box',{attrs:{"bg":"white","rounded":"","shadow":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }